import React from "react";
import PropTypes from 'prop-types';
import IconButton from "../IconButton";

import backButton from "./../../../img/back-button.svg";
import backButtonInverted from "./../../../img/back-button-inverted.svg";

import editButton from "./../../../img/edit-button.svg";
import editButtonInverted from "./../../../img/edit-button-inverted.svg";

import deleteButton from "./../../../img/delete-button.svg";
import deleteButtonInverted from "./../../../img/delete-button-inverted.svg";
import { connect } from 'react-redux';
import { userHasPermission, modulesActions } from "../../../../roles/components/UserHasPermission";

const FormButtons = ({
    editMode,
    viewMode,
    hasDelete = true,
    hasEdit = true,
    handleBackClick,
    handleEditClick,
    handleDeleteClick,
    userPermissions,
    appModule
}) => {
    return (
        <>
            <IconButton
                alt="back"
                handleIconClick={handleBackClick}
                image={backButton}
                invertedImage={backButtonInverted}
            />
            {
                (hasEdit &&
                    (viewMode || editMode) &&
                    userHasPermission(appModule, modulesActions.UPDATE, userPermissions)
                ) && (
                    <IconButton
                        alt="edit"
                        selected={editMode}
                        handleIconClick={handleEditClick}
                        image={editButton}
                        invertedImage={editButtonInverted}
                    />
                )
            }
            {
                (hasDelete &&
                    (viewMode || editMode) &&
                    userHasPermission(appModule, modulesActions.DELETE, userPermissions)
                ) && (
                    <IconButton
                        alt="delete"
                        handleIconClick={handleDeleteClick}
                        image={deleteButton}
                        invertedImage={deleteButtonInverted}
                    />
                )
            }
        </>
    )
}

FormButtons.propTypes = {
    normal: PropTypes.string,
    inverted: PropTypes.string,
    editMode: PropTypes.bool,
    viewMode: PropTypes.bool,
    hasDelete: PropTypes.bool,
    handleBackClick: PropTypes.func,
    handleEditClick: PropTypes.func,
    handleDeleteClick: PropTypes.func,
}

const mapStateToProps = ({ authReducer }) => ({
    userPermissions: authReducer.user && authReducer.user.role ? authReducer.user.role.permissions : []
})

export default connect(
    mapStateToProps,
    null
)(FormButtons);